import { AxiosResponse } from 'axios';
import { DeclarationsListVM } from 'civil-status/view-models/research-form-icaro';
import { DateTime } from 'luxon';
import { HttpResponseList, HttpResponseListPayload } from 'shell/models/http-response';
import { SearchDeclaration } from 'shell/models/search-declaration';

export const transformerDeclarationsList = (
  response: AxiosResponse<HttpResponseList<SearchDeclaration>>
): Array<DeclarationsListVM> => {
  const listResponse = (response.data?.payload || []) as unknown as Array<SearchDeclaration>;
  const totalCount = ((response.data as unknown as HttpResponseListPayload<SearchDeclaration>)
    ?.pageInfo?.totalCount || 0) as number;

  return listResponse.map((item) => ({
    hospital: item.ospedale || '',
    dateArrive: item.dataArrivo ? DateTime.fromISO(item.dataArrivo).toFormat('dd/MM/yyyy') : '',
    dateBorn: item.dataNascita ? DateTime.fromISO(item.dataNascita).toFormat('dd/MM/yyyy') : '',
    dateDeclaration: item.dataDichiarazione
      ? DateTime.fromISO(item.dataDichiarazione).toFormat('dd/MM/yyyy')
      : '',
    idAnsc: item.attoNascita || '',
    idState: item.idStato || '',
    numberDeclaration: item.numeroDichiarazione || '',
    state: item.stato || '',
    surnameName: item.nominativo || '',
    contatore: item.contatore,
    twins: item.numeroGemello || '',
    totalCount,
  }));
};
